/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getNote = /* GraphQL */ `query GetNote($id: ID!) {
  getNote(id: $id) {
    id
    title
    trip {
      id
      owner
      tripName
      destination
      startDate
      endDate
      tripImageUrl
      tripImageKey
      notes {
        items {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      profile {
        id
        owner
        username
        followers
        following
        profilePicture {
          original
          small
          medium
          large
          __typename
        }
        trips {
          nextToken
          startedAt
          __typename
        }
        email
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      profileTripsId
      __typename
    }
    note
    owner
    coords {
      lat
      long
      __typename
    }
    locationName
    createdAt
    images
    tags {
      items {
        id
        noteID
        tagID
        note {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        tag {
          id
          label
          owner
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    updatedAt
    _version
    _deleted
    _lastChangedAt
    tripNotesId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetNoteQueryVariables, APITypes.GetNoteQuery>;
export const listNotes = /* GraphQL */ `query ListNotes(
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      trip {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      note
      owner
      coords {
        lat
        long
        __typename
      }
      locationName
      createdAt
      images
      tags {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      tripNotesId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListNotesQueryVariables, APITypes.ListNotesQuery>;
export const syncNotes = /* GraphQL */ `query SyncNotes(
  $filter: ModelNoteFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncNotes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      title
      trip {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      note
      owner
      coords {
        lat
        long
        __typename
      }
      locationName
      createdAt
      images
      tags {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      tripNotesId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncNotesQueryVariables, APITypes.SyncNotesQuery>;
export const getTag = /* GraphQL */ `query GetTag($id: ID!) {
  getTag(id: $id) {
    id
    label
    notes {
      items {
        id
        noteID
        tagID
        note {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        tag {
          id
          label
          owner
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTagQueryVariables, APITypes.GetTagQuery>;
export const listTags = /* GraphQL */ `query ListTags($filter: ModelTagFilterInput, $limit: Int, $nextToken: String) {
  listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      label
      notes {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTagsQueryVariables, APITypes.ListTagsQuery>;
export const syncTags = /* GraphQL */ `query SyncTags(
  $filter: ModelTagFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTags(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      label
      notes {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncTagsQueryVariables, APITypes.SyncTagsQuery>;
export const getTrip = /* GraphQL */ `query GetTrip($id: ID!) {
  getTrip(id: $id) {
    id
    owner
    tripName
    destination
    startDate
    endDate
    tripImageUrl
    tripImageKey
    notes {
      items {
        id
        title
        trip {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        note
        owner
        coords {
          lat
          long
          __typename
        }
        locationName
        createdAt
        images
        tags {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
        tripNotesId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    profile {
      id
      owner
      username
      followers
      following
      profilePicture {
        original
        small
        medium
        large
        __typename
      }
      trips {
        items {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      email
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    profileTripsId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTripQueryVariables, APITypes.GetTripQuery>;
export const listTrips = /* GraphQL */ `query ListTrips(
  $filter: ModelTripFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrips(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      tripName
      destination
      startDate
      endDate
      tripImageUrl
      tripImageKey
      notes {
        items {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      profile {
        id
        owner
        username
        followers
        following
        profilePicture {
          original
          small
          medium
          large
          __typename
        }
        trips {
          nextToken
          startedAt
          __typename
        }
        email
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      profileTripsId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTripsQueryVariables, APITypes.ListTripsQuery>;
export const syncTrips = /* GraphQL */ `query SyncTrips(
  $filter: ModelTripFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTrips(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      owner
      tripName
      destination
      startDate
      endDate
      tripImageUrl
      tripImageKey
      notes {
        items {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      profile {
        id
        owner
        username
        followers
        following
        profilePicture {
          original
          small
          medium
          large
          __typename
        }
        trips {
          nextToken
          startedAt
          __typename
        }
        email
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      profileTripsId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncTripsQueryVariables, APITypes.SyncTripsQuery>;
export const getProfile = /* GraphQL */ `query GetProfile($id: ID!) {
  getProfile(id: $id) {
    id
    owner
    username
    followers
    following
    profilePicture {
      original
      small
      medium
      large
      __typename
    }
    trips {
      items {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    email
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProfileQueryVariables,
  APITypes.GetProfileQuery
>;
export const listProfiles = /* GraphQL */ `query ListProfiles(
  $filter: ModelProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  listProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      username
      followers
      following
      profilePicture {
        original
        small
        medium
        large
        __typename
      }
      trips {
        items {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      email
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProfilesQueryVariables,
  APITypes.ListProfilesQuery
>;
export const syncProfiles = /* GraphQL */ `query SyncProfiles(
  $filter: ModelProfileFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncProfiles(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      owner
      username
      followers
      following
      profilePicture {
        original
        small
        medium
        large
        __typename
      }
      trips {
        items {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      email
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncProfilesQueryVariables,
  APITypes.SyncProfilesQuery
>;
export const getNoteTags = /* GraphQL */ `query GetNoteTags($id: ID!) {
  getNoteTags(id: $id) {
    id
    noteID
    tagID
    note {
      id
      title
      trip {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      note
      owner
      coords {
        lat
        long
        __typename
      }
      locationName
      createdAt
      images
      tags {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      tripNotesId
      __typename
    }
    tag {
      id
      label
      notes {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNoteTagsQueryVariables,
  APITypes.GetNoteTagsQuery
>;
export const listNoteTags = /* GraphQL */ `query ListNoteTags(
  $filter: ModelNoteTagsFilterInput
  $limit: Int
  $nextToken: String
) {
  listNoteTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      noteID
      tagID
      note {
        id
        title
        trip {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        note
        owner
        coords {
          lat
          long
          __typename
        }
        locationName
        createdAt
        images
        tags {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
        tripNotesId
        __typename
      }
      tag {
        id
        label
        notes {
          nextToken
          startedAt
          __typename
        }
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNoteTagsQueryVariables,
  APITypes.ListNoteTagsQuery
>;
export const syncNoteTags = /* GraphQL */ `query SyncNoteTags(
  $filter: ModelNoteTagsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncNoteTags(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      noteID
      tagID
      note {
        id
        title
        trip {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        note
        owner
        coords {
          lat
          long
          __typename
        }
        locationName
        createdAt
        images
        tags {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
        tripNotesId
        __typename
      }
      tag {
        id
        label
        notes {
          nextToken
          startedAt
          __typename
        }
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncNoteTagsQueryVariables,
  APITypes.SyncNoteTagsQuery
>;
